import { render, staticRenderFns } from "./PHQ.vue?vue&type=template&id=25138c4e&"
import script from "./PHQ.vue?vue&type=script&lang=js&"
export * from "./PHQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports